var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83918_34299)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42 16H82V24H-39.1544L-42 16Z",
    fill: "url(#paint0_linear_83918_34299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50 0H82V8H-46.8192L-50 0Z",
    fill: "url(#paint1_linear_83918_34299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39 24H82V32H-39V24Z",
    fill: "url(#paint2_linear_83918_34299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 8H82V16H-45V8Z",
    fill: "url(#paint3_linear_83918_34299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 8H82V16H-45V8Z",
    fill: "url(#paint4_linear_83918_34299)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83918_34299",
    x1: 16.3874,
    y1: 20.2,
    x2: 16.3874,
    y2: 29.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FEA514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#FF4539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83918_34299",
    x1: 16.4742,
    y1: 4.2,
    x2: 16.4736,
    y2: 13.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#139EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#B9F7EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_83918_34299",
    x1: 16.2976,
    y1: 28.2,
    x2: 16.2969,
    y2: 37.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBFFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#48DD13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#008805"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_83918_34299",
    x1: 16.0562,
    y1: 8.98767,
    x2: 16.0562,
    y2: 16.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529819,
    stopColor: "#FF5544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955545,
    stopColor: "#E63E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_83918_34299",
    x1: 14.8003,
    y1: 12.2,
    x2: 14.7996,
    y2: 21.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#FE1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#8E0900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83918_34299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeam);
export default __webpack_public_path__ + "static/media/beam.3fae2b0097ed2f815a64ca85162ab573.svg";
export { ForwardRef as ReactComponent };